<router-outlet></router-outlet>
<div class="loading" *ngIf="loading">
  <mat-progress-bar color="primary" mode="indeterminate">
  </mat-progress-bar>
</div>

<div *ngIf="routing" class="full-size router-info">
  <div class="white">
    <gio-logo [animate]="false"></gio-logo>
    <h2 class="loading-text-data">Carregando...</h2>
    <i class="fa fa-2x fa-spin fa-spinner"></i>
  </div>
</div>

<div class="connection-info" *ngIf="!(isConnected$ |async)"><i class="fa fa-wifi"></i>&nbsp;&nbsp;internet desconectada
</div>
<ng-container *ngIf="showCookieDialog">
  <gio-cookie-message (accepted)="showCookieDialog = false"></gio-cookie-message>
</ng-container>
